import MainContents from "./components/layouts/MainContents";

const App: React.FC = () => {
  return (
    <div>
      <MainContents />
    </div>
  );
};

export default App;
